import { Button, Heading, Icon, IconButton, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { FaArrowLeft, FaArrowRight, FaColumns, FaFileExcel, FaFilter, FaSync } from "react-icons/fa";
import { FcCheckmark } from 'react-icons/fc';

export default function PracticeDashboard() {
    const [invs] = useState([
        {
            ref: 1,
            businessName: "Inaam Space Research Organization",
            businessShortName: "ISRO",
            entityEmail: "info@isro.org",
            type: "Non Profit Organization",
            vatGST: '-',
            accountingSoftware: <Icon as={FaFileExcel} color={'#4C8766'} w={'15px'} h={'15px'} />,
            processing: 12,
            processed: 6,
            approvedExported: 3,
            lastUpload: 17,
            newReporting: '',
            dueDate: '2023-07-01'
        },
        {
            ref: 2,
            businessName: "Insight Ways Private Limited",
            businessShortName: "IWPL",
            entityEmail: "hello@entry-bot.com",
            type: "Limited Company",
            vatGST: <Icon as={FcCheckmark} color={'#4C8766'} w={'15px'} h={'15px'} />,
            accountingSoftware: <Icon as={FaFileExcel} color={'#4C8766'} w={'15px'} h={'15px'} />,
            processing: 12,
            processed: 6,
            approvedExported: 3,
            lastUpload: 17,
            newReporting: '',
            dueDate: '2023-08-01'
        }
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={BsFillGrid3X3GapFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Practice Dashboard</Heading>
                            <Text fontSize={'sm'}>A bookkeeping overview of all your clients</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaColumns />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Columns
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaSync />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Refresh
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaFilter />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Clear Filter
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer
                    css={{
                        '&::-webkit-scrollbar-thumb': {
                            background: '#5E5E5E',
                        },
                    }}
                >
                    <Table
                        size='sm'
                    >
                        <Thead  position={'sticky'} top={'0%'} h={'50px'} bg={'#5E5E5E'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    color={'white'}
                                    isNumeric
                                >
                                    Ref
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Business Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Business Short Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Entity Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Type
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    VAT/GST
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Accounting Software
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Processing
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Processed
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Approved / Exported
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Days Since Last Upload
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    New Reporting
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Due Date
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.map(inv => (
                                    <Tr>
                                        <Td isNumeric>{inv.ref}</Td>
                                        <Td>{inv.businessName}</Td>
                                        <Td>{inv.businessShortName}</Td>
                                        <Td>{inv.entityEmail}</Td>
                                        <Td>{inv.type}</Td>
                                        <Td textAlign={'center'}>{inv.vatGST}</Td>
                                        <Td textAlign={'center'}>{inv.accountingSoftware}</Td>
                                        <Td isNumeric>{inv.processing}</Td>
                                        <Td isNumeric>{inv.processed}</Td>
                                        <Td isNumeric>{inv.approvedExported}</Td>
                                        <Td isNumeric>{inv.lastUpload}</Td>
                                        <Td isNumeric>{inv.newReporting}</Td>
                                        <Td isNumeric>{inv.dueDate}</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}